// src/features/product-tours/tourRegistry.ts

import { ALL_TOUR_DEFINITIONS } from './definitions/allTours';
import { HELP_CENTER_GUIDES, HELP_FAQ_ENTRIES } from './helpCenterCatalog';
import type { ProductTourDefinition, ProductTourId } from './types';

const REGISTRY: Record<ProductTourId, ProductTourDefinition> = ALL_TOUR_DEFINITIONS.reduce(
  (acc, def) => {
    acc[def.id] = def;
    return acc;
  },
  {} as Record<ProductTourId, ProductTourDefinition>
);

export function getProductTour(tourId: ProductTourId): ProductTourDefinition | undefined {
  return REGISTRY[tourId];
}

export function listProductTours(): ProductTourDefinition[] {
  return Object.values(REGISTRY);
}

export { HELP_CENTER_GUIDES, HELP_FAQ_ENTRIES };
